<script>
    import UIkit from 'uikit';

    export default {
        props: {
            ShopItems: {
                type: Object,
                default() {
                    return {}
                }
            },
            ShopItemPrices: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemsRelated: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemProperties: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemWarehouses: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemTags: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopOrderItems: {
                type: [Array, Object],
                default() {
                    return []
                }
            }
        },
        data() {
            return {
                loading: false,
                browserHistory: {},
            }
        },
        methods: {
            buy(quantity, ShopItem) {
                this.loading = true;
                this.$http.put('/cart/buy', {
                    quantity: quantity,
                    shopItemId: ShopItem.id
                }).then(
                    (response) => {
                        this.page.ShopOrderItems = response.body.data.shopOrderItems;
                        this.loading = false;
                        this.$bus.$emit('update-navbar-cart');
                    }
                )

            },
            fetchShopItems(href, params = {}, pushHistory = true, reload = true) {
                this.loading = true;
                this.href = href;
                this.$http.get(href, {
                    params: params
                }).then(response => {

                    this.page = response.body.data;


                    this.loading = false;

                    if(reload === true) {
                        UIkit.scroll('#js-scroll').scrollTo('#galactium');
                    }

                    if (pushHistory) {
                        this.pushToHistory(response.url, params);
                    }
                }, response => {
                    this.loading = false;
                })
            },
            bindHistoryManipulation(href, params = {}) {
                this.browserHistory = window.history;
                window.addEventListener('popstate', (event) => {
                    console.log(event)
                    if (event.state) {
                        this.fetchShopItems(href, event.state, false)
                    } else {
                        window.location.href = location.href
                    }
                });
                console.log(params);
                this.browserHistory.replaceState(params, '', href);
            },
            pushToHistory(url, params) {
                this.browserHistory.pushState(params, '', url);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ShopProductsMixin.vue?435df042